import { MenuSectionType } from 'types/graphql';
import { MenuSectionOption, Section } from './homepage-form.types';

export const PRODUCT_LIMIT = 25;

const didNotFindSectionByType = (menuSections: Section[], type: MenuSectionType): boolean =>
  !menuSections.find((menuSection) => menuSection.sectionType === type);

export const defaultSectionOptions: MenuSectionOption[] = [
  {
    key: MenuSectionType.category,
    title: 'Popular Category',
    tooltip: 'Display a section of the most popular items in a top level category, for example “Popular Edibles”.',
    visible: true,
  },
  {
    key: MenuSectionType.subcategory,
    title: 'Popular Subcategory',
    tooltip: 'Display a section of the most popular items in a subcategory, for example “Popular Gummies”.',
    visible: true,
  },
  {
    key: MenuSectionType.brand,
    title: 'Brand',
    tooltip: 'Display a section of the most popular items for the selected brand.',
    visible: true,
  },
  {
    key: MenuSectionType.custom,
    title: 'Custom',
    tooltip: 'Display a section that shows selected products from your menu.',
    visible: true,
  },
  {
    key: MenuSectionType.collection,
    title: 'Collection',
    tooltip: 'Display a section with products from this Collection.',
    // TODO update this?
    visible: true,
  },
  {
    key: MenuSectionType.image,
    title: 'Image',
    tooltip: 'Display a section with an image.',
    visible: true,
  },
];

export const dynamicSectionOptions: MenuSectionOption[] = [
  {
    key: MenuSectionType.recentlyViewed,
    title: 'Recently Viewed',
    tooltip: 'Display a section that shows items that the user has recently viewed.',
    visible: (menuSections: Section[]) => didNotFindSectionByType(menuSections, MenuSectionType.recentlyViewed),
  },
  {
    key: MenuSectionType.specials,
    title: 'Items on Sale',
    tooltip: 'Display a section that shows items that are currently on special.',
    visible: (menuSections: Section[]) => didNotFindSectionByType(menuSections, MenuSectionType.specials),
  },
  {
    key: MenuSectionType.staffPicks,
    title: 'Staff Picks',
    tooltip: 'Display a section that shows items that are currently selected as Staff Picks.',
    visible: (menuSections: Section[]) => didNotFindSectionByType(menuSections, MenuSectionType.staffPicks),
  },
  {
    key: MenuSectionType.topSellers,
    title: 'Top Sellers',
    tooltip: 'Display a section that shows the top selling items on your entire menu.',
    visible: (menuSections: Section[]) => didNotFindSectionByType(menuSections, MenuSectionType.topSellers),
  },
  {
    key: MenuSectionType.offers,
    title: 'Offers',
    tooltip: 'Display a section of your promotional Offers.',
    visible: (menuSections: Section[]) => didNotFindSectionByType(menuSections, MenuSectionType.offers),
  },
  {
    key: MenuSectionType.recommendedForYou,
    title: 'Recommended For You',
    tooltip: 'Display a section that shows items recommended for the user.',
    visible: (menuSections: Section[]) => didNotFindSectionByType(menuSections, MenuSectionType.recommendedForYou),
  },
];

export const allSectionOptions = [...defaultSectionOptions, ...dynamicSectionOptions];

export const DYNAMIC_LABEL_MAP = {
  [MenuSectionType.offers]: 'Offers',
  [MenuSectionType.recentlyViewed]: 'Recently Viewed',
  [MenuSectionType.recommendedForYou]: 'Recommended For You',
  [MenuSectionType.specials]: 'Items on Sale',
  [MenuSectionType.staffPicks]: 'Staff Picks',
  [MenuSectionType.topSellers]: 'Top Sellers',
};

export const DEFAULT_SECTIONS = [
  MenuSectionType.category,
  MenuSectionType.subcategory,
  MenuSectionType.brand,
  MenuSectionType.custom,
  MenuSectionType.collection,
  MenuSectionType.image,
];

export const DYNAMIC_SECTIONS = [
  MenuSectionType.offers,
  MenuSectionType.recentlyViewed,
  MenuSectionType.recommendedForYou,
  MenuSectionType.specials,
  MenuSectionType.staffPicks,
  MenuSectionType.topSellers,
];

export const EDITABLE_SECTIONS = [MenuSectionType.custom, MenuSectionType.collection, MenuSectionType.image];
